import { render, staticRenderFns } from "./HeaderNavBlogPosts.vue?vue&type=template&id=1c10355d&scoped=true&"
import script from "./HeaderNavBlogPosts.vue?vue&type=script&lang=js&"
export * from "./HeaderNavBlogPosts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c10355d",
  null
  
)

export default component.exports